import { Button } from '@/components/Button';
import { ContactBox } from '@/components/ContactBox';
import { DisplayComponent } from '@/components/DisplayComponent';
import { Header } from '@/components/Header';
import { RemoteImage } from '@/components/RemoteImage';
import { setPaidAmount } from '@/context/borrower';
import { EDisplays, setDisplay } from '@/context/display';
import { useAppDispatch } from '@/context/storeHooks';

const baseId = 'screen-IncomeIneligible';

export function IncomeIneligible(): JSX.Element {
    // ***** Redux State *****
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleIncomeChange(): void {
        dispatch(setPaidAmount(undefined));
        dispatch(setDisplay(EDisplays.INCOME));
    }

    return (
        <DisplayComponent baseId={baseId} data-testid={baseId}>
            <Header />
            {/* The sentence is what the customer needs; at 160px the mark
                pushed it below the fold on a phone. */}
            <div className='flex-center py-6 relative'>
                <div className='bg-primary h-24 w-24 rounded-full' />
                <RemoteImage fileName='coins.svg' className='absolute h-12' />
            </div>
            {/* One alignment and one spacing mechanism: the heading was
                centred over left-aligned copy, with spacing set on the
                container and on the children at once. */}
            <div className='mx-6 _flex flex-col gap-3'>
                <h3 className='text-xl text-primary font-bold'>
                    Minimum income not met
                </h3>
                <p className='text-secondary'>
                    Your current income level does not meet the minimum
                    requirement for a novated lease.
                </p>
                <p className='text-sm text-textMuted'>
                    To ensure affordability, novated leases require a minimum
                    taxable income threshold. If your salary is below this, it
                    may not be a suitable option at this time.
                </p>
                <p className='text-sm text-textMuted'>
                    You may want to check with your employer for salary
                    packaging alternatives or explore other financing options.
                </p>
            </div>
            <div className='_flex space-x-2 mx-6 pt-6'>
                <Button
                    id={`${baseId}-button-reduceLoan`}
                    onClick={handleIncomeChange}
                >
                    Edit Income Details
                </Button>
            </div>
            <div className='flex-center w-full'>
                <ContactBox />
            </div>
        </DisplayComponent>
    );
}
